import { ParameterKeyValueProps, ParameterProps } from "./types"

const serviceUrl = "/services/plugin-run-parameters/parameters"

const getRunPath = (signal, wellName, span) => fetch(`${serviceUrl}/runpath/${wellName}/${span}`, { signal })

const getOperationSpanPickerRunPath = (signal, dashboardId, wellName) => fetch(`/services/plugin-drilling-operations-span-picker/tree/runPath/${dashboardId}/${wellName}`, { signal })

const getDefaultParameters = (signal) => fetch(`${serviceUrl}/default`, { signal })
const saveDefaultParameters = (payload: ParameterProps[]) =>
    fetch(`${serviceUrl}/default`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })


const getDashboardParameters = (signal, dashboardId) => fetch(`${serviceUrl}/dashboard/${dashboardId}`, { signal })
const saveDashboardParameters = (dashboardId: number, payload: String[]) =>
    fetch(`${serviceUrl}/dashboard/${dashboardId}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })


const getRunParametersByRunPath = (signal, wellName, interventionId, drillingSectionPosIndex, runPosIndex) => fetch(`${serviceUrl}/${wellName}/${interventionId}/${drillingSectionPosIndex}/${runPosIndex}`, { signal })
const getRunParameters = (signal, wellName, span) => fetch(`${serviceUrl}/${wellName}/${span}`, { signal })
const saveRunParametersByRunPath = (wellName, interventionId, drillingSectionPosIndex, runPosIndex, payload: ParameterKeyValueProps[]) =>
    fetch(`${serviceUrl}/${wellName}/${interventionId}/${drillingSectionPosIndex}/${runPosIndex}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
const saveRunParameters = (wellName, span, payload: ParameterKeyValueProps[]) =>
    fetch(`${serviceUrl}/${wellName}/${span}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })


const getUserParametersByRunPath = (signal, wellName, interventionId, drillingSectionPosIndex, runPosIndex) => fetch(`${serviceUrl}/user/${wellName}/${interventionId}/${drillingSectionPosIndex}/${runPosIndex}`, { signal })
const getUserParameters = (signal, wellName, span) => fetch(`${serviceUrl}/user/${wellName}/${span}`, { signal })
const saveUserParametersByRunPath = (wellName, interventionId, drillingSectionPosIndex, runPosIndex, payload: ParameterKeyValueProps[]) =>
    fetch(`${serviceUrl}/user/${wellName}/${interventionId}/${drillingSectionPosIndex}/${runPosIndex}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
const saveUserParameters = (wellName, span, payload: ParameterKeyValueProps[]) =>
    fetch(`${serviceUrl}/user/${wellName}/${span}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })

const getRunParametersHistoryByRunPath = (signal, wellName, interventionId, drillingSectionPosIndex, runPosIndex) => fetch(`${serviceUrl}/history/${wellName}/${interventionId}/${drillingSectionPosIndex}/${runPosIndex}`, { signal })
const getRunParametersHistory = (signal, wellName, span) => fetch(`${serviceUrl}/history/${wellName}/${span}`, { signal })
const deleteRunParametersHistoryItem = (wellName, span, createdAtTimestamp: number) =>
    fetch(`${serviceUrl}/history/${wellName}/${span}/${createdAtTimestamp}`, {
        method: 'delete',
        headers: {
            'Content-Type': 'application/json'
        }
    })


export default {
    getOperationSpanPickerRunPath,
    getRunPath,
    getDefaultParameters,
    saveDefaultParameters,
    getDashboardParameters,
    saveDashboardParameters,
    getRunParameters,
    saveRunParameters,
    getUserParameters,
    saveUserParameters,
    getRunParametersHistory,
    deleteRunParametersHistoryItem,
    getRunParametersByRunPath,
    getUserParametersByRunPath,
    getRunParametersHistoryByRunPath,
    saveRunParametersByRunPath,
    saveUserParametersByRunPath
}
